import { getGdprCookie } from '../../projects/gdpr/domain/gdpr-provider';
import { gtmCreateAccount } from './gtm-provider';
import { initAdwords } from './adwords-provider';
import { tiktokCreateAccount } from './tiktok-provider';
import { outbrainRegistrationEvent } from './outbrain-provider';
import { impactRadiusCreateAccount } from './impact-radius-provider';

export const sendRegistrationEvents = async () => {

    const gdpr = getGdprCookie();
    const isMarketing = gdpr.IsMarketing;
    const isFunctional = gdpr.IsFunctional;

    // send data to GTM after registration
    gtmCreateAccount();

    if(isMarketing){

        // init adwords script
        initAdwords();

        // Marketing create account events.
        tiktokCreateAccount();
        outbrainRegistrationEvent();
    }

    if(isFunctional){
        // impact radius
        impactRadiusCreateAccount();
    }
};